import Button from "@/components/base/Button";

export default function NotFound() {
  return (
    <main className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden px-6 py-24 md:px-12">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-1/2 -z-10 -translate-x-1/2 select-none font-syncopator text-[34vw] leading-none text-moss/10"
      >
        404
      </span>

      <div className="relative mx-auto w-full max-w-xl text-center">
        <span className="inline-block text-xs tracking-[0.4em] uppercase text-moss mb-6">
          · Hier wächst nichts
        </span>
        <h1 className="font-display font-light text-4xl leading-[1.1] text-ink md:text-6xl">
          Diese Seite
          <br />
          haben wir noch nicht gepflanzt.
        </h1>
        <p className="mx-auto mt-6 max-w-md text-sm leading-relaxed text-inkDim md:text-base">
          Vielleicht hat sich der Link vertippt, vielleicht ist die Seite
          umgezogen. Zurück ins Grüne geht es hier lang.
        </p>

        <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
          <Button to="/" size="lg" className="bg-sage text-bg hover:bg-ink">
            Zur Startseite
            <i className="ri-arrow-right-line"></i>
          </Button>
          <Button
            to="/karriere"
            size="lg"
            variant="outline"
            className="border-ink/20 hover:bg-ink hover:text-bg"
          >
            Offene Stellen
          </Button>
        </div>
      </div>
    </main>
  );
}